module.exports = __webpack_public_path__ + "img/project-started.c7439951.png";